import { render, staticRenderFns } from "./Gongzi.vue?vue&type=template&id=12ce1e0c&scoped=true&"
import script from "./Gongzi.vue?vue&type=script&lang=js&"
export * from "./Gongzi.vue?vue&type=script&lang=js&"
import style0 from "./Gongzi.vue?vue&type=style&index=0&id=12ce1e0c&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ce1e0c",
  null
  
)

export default component.exports